import React from 'react';
import type { SVGDefaultProps } from './types';
import { colors } from '@/styles';
import { isColorName } from '@/styles/colorUtils';

export const ArrowSmall = ({
  size = '16',
  title = 'Arrow',
  fill = colors.silverSandAlt,
}: SVGDefaultProps) => {
  const height = Number(size) * 2.85;

  let svgFill = fill;
  if (isColorName(fill)) {
    console.warn('Using deprecated fill prop for ArrowSmall svg, fill should be a hex.');
    svgFill = colors[fill];
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 8.59 13.54">
      {Boolean(title) && <title>{title}</title>}
      <path
        d={`
M2.39,13.15l6-5.94a.6.6,0,0,0,.18-.42h0a.58.58,0,0,0-.17-.41L2.28.44A1.34,
1.34,0,0,0,1.33,0a1.27,1.27,0,0,0-1,.37l-.1.1A1.31,1.31,0,0,0,.42,2.25L4.9,
6.73.43,11.21a1.38,1.38,0,0,0,2,1.95Z
`}
        fill={svgFill}
      />
    </svg>
  );
};
